<template>
  <BaseModal
    :id="id"
    :modalClass="`modal-md`"
    :showCloseButton="false"
  >
    <template #header>
      <h5 class="modal-title">
        {{ $t('message.titlefreetrialended') }}
      </h5>
    </template>
    <template #body>
      <div class="container-body">
        <p
          class="mb-0"
          v-html="$t('message.bodyfreetrialended1')"/>
      </div>
    </template>
    <template #footer>
      <div class="container-footer">
        <div>
          <button
            type="button"
            class="btn btn-web"
            @click="onClickAck">
            {{ $t('button.acknowledge') }}
          </button>
        </div>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    id: {
      type: String,
      default: null,
    },
  },

  methods: {
    onClickAck () {
      $(`#${this.id}`).modal('hide')
      this.$emit('onClose')
    },
  },
}
</script>

<style scoped>
.container-body {
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseModalAckFreeTrialEnded.vue